import {
  Breakpoints,
  FontFamily,
  PrimaryColors,
} from '@/common/theme/constants';
import { SxProps } from '@mui/material';

export const styledPriceWrapper: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',

  [`@media (min-width:${Breakpoints.sm}px)`]: {
    flexDirection: 'row',
    gap: '0.5rem',
    alignItems: 'baseline',
  },
};

export const styledPriceText: SxProps = {
  fontFamily: FontFamily.heading,

  [`@media (min-width:${Breakpoints.sm}px)`]: {
    paddingBottom: '3px',
  },
};

export const styledActualTermPriceWithPeriod: SxProps = {
  display: 'flex',
  alignItems: 'baseline',
  gap: '0.2rem',
};

export const stylesCrossedOutPrice: SxProps = {
  ...styledPriceText,
  fontFamily: FontFamily.body,
  color: PrimaryColors.grey,
  textDecoration: 'line-through',
};

export const styledPeriodText: SxProps = {
  textTransform: 'capitalize',
};

export const styledPriceBox: SxProps = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',

  [`@media (min-width:${Breakpoints.sm}px)`]: {
    mt: '20px',
    width: 'auto',
    alignItems: 'baseline',
  },
};
